export default {
  goal: {
    title: '目標',
    fromStudy:
      'スタディから事前入力されています。結果はソースのバージョンのもので、このドラフトのものではありません。',
    atDp: '{{dp}} での値',
  },
  files: {
    draftRow: 'ドラフト · 未保存',
    draftLoading: '読み込み中…',
    draftRevision: 'rev {{revision}}',
  },
  viewer: {
    draft: 'ドラフト',
    source: 'ソース',
    unsavedDraft: '未保存のドラフト rev {{revision}}',
    loadingDraft: 'ドラフトを読み込み中…',
    updating: '更新中…',
    earlierRevision: '以前のリビジョンを表示中',
    draftUnavailable: 'ドラフトのプレビューを表示できません: {{message}}',
    draftExpired: 'ドラフトのプレビューは期限切れか、利用できなくなりました。',
    draftClosed: 'ドラフトが破棄されたか、セッションが利用できなくなりました。',
    notSimulated:
      'ドラフト rev {{revision}} はまだシミュレーションされていません。ここに表示される結果はすべて v{{version}} のものです。',
  },
  advisor: {
    discardDraft: 'ドラフトを破棄',
  },
  draftHealth: {
    title: 'ドラフトの健全性',
    sessionChecks: 'セッションのチェック',
    sessionChecksHint:
      'このリビジョンを作成したときにアシスタント自身が行ったチェックの結果です。',
    checksPending:
      'このリビジョンに対するアシスタントのチェックを待っています。',
    checksPassed: 'rev {{revision}} で合格',
    checksPassedBody:
      '編集が実行され、ソリッドが生成されました。メッシュ化の可否の判定ではありません。',
    checksFailed: 'rev {{revision}} で不合格',
    topology: 'トポロジー',
    topologyUnavailable: 'このリビジョンのトポロジーチェックはありません。',
    topologyPending: 'このリビジョンのトポロジーをチェックしています…',
    topologyFailed: 'トポロジーチェックが完了しませんでした',
    topologyFailedBody:
      'ドラフトは引き続きレビュー・保存できます。保存したバージョンは通常どおり診断されます。',
    review: 'レビューして v{{version}} として保存',
  },
  review: {
    pair: 'v{{version}} ソース ↔ ドラフト rev {{revision}}',
    notValidated: '未検証',
    notValidatedBody:
      'このワークスペースの圧力・温度・力の値はすべて v{{version}} のものです。このドラフトは一度もシミュレーションされていません。',
    summaryPlaceholder:
      '何を変更し、何を狙ったか — 例: 「ポート Ø12 → Ø14、リブ 6 → 4、ΔP ≤ 15 kPa を目標」',
    eyebrow: 'CadMorph ドラフト',
    title: 'ドラフト rev {{revision}} のレビュー',
    summaryLabel: '変更内容',
    healthTitle: '健全性',
    metricsTitle: 'ジオメトリ',
    blocking: 'ブロッキングの問題',
    quality: '品質の問題',
    notChecked: '未チェック',
    checkFailed: 'チェック失敗',
    topologyFailed: 'トポロジーチェック: {{message}}',
    passed: '合格',
    failed: '不合格',
    reject: '却下',
    approve: '承認して v{{version}} として保存',
    approvalNote:
      '書き込む前に、アシスタントがチャットで保存の承認を求めます。',
    back: 'ドラフトの健全性に戻る',
  },
} as const;
